module.exports = __webpack_public_path__ + "img/bg.66be9e26.jpg";